function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* global React, ReactDOM, window, PRODUCTS, COLLECTIONS */
/* global Header, Hero, ValueStrip, FeaturedCollections, ProductRow */
/* global Manifesto, IssuesBlock, CalendarBlock, DispatchBlock, Testimonials, Newsletter */
/* global CollectionPage, ProductDetailPage, CartDrawer, Footer */
// ============================================================================
// App — Shopify-hosted version. Uses Shopify cart API for real checkout.
// ============================================================================
var _React = React,
  useStateApp = _React.useState,
  useEffectApp = _React.useEffect;

// Shopify cart helpers
function shopifyAddToCart(_x) {
  return _shopifyAddToCart.apply(this, arguments);
}
function _shopifyAddToCart() {
  _shopifyAddToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(items) {
    var res, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: items
            })
          });
        case 1:
          res = _context.v;
          return _context.a(2, res.ok);
        case 2:
          _context.p = 2;
          _t = _context.v;
          return _context.a(2, false);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return _shopifyAddToCart.apply(this, arguments);
}
function shopifyCheckout() {
  return _shopifyCheckout.apply(this, arguments);
}
function _shopifyCheckout() {
  _shopifyCheckout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          window.location.href = '/checkout';
        case 1:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _shopifyCheckout.apply(this, arguments);
}
function App() {
  var _useStateApp = useStateApp("home"),
    _useStateApp2 = _slicedToArray(_useStateApp, 2),
    screen = _useStateApp2[0],
    setScreen = _useStateApp2[1];
  var _useStateApp3 = useStateApp("best-sellers"),
    _useStateApp4 = _slicedToArray(_useStateApp3, 2),
    collId = _useStateApp4[0],
    setCollId = _useStateApp4[1];
  var _useStateApp5 = useStateApp(PRODUCTS[0]),
    _useStateApp6 = _slicedToArray(_useStateApp5, 2),
    product = _useStateApp6[0],
    setProduct = _useStateApp6[1];
  var _useStateApp7 = useStateApp([]),
    _useStateApp8 = _slicedToArray(_useStateApp7, 2),
    cart = _useStateApp8[0],
    setCart = _useStateApp8[1];
  var _useStateApp9 = useStateApp(false),
    _useStateApp0 = _slicedToArray(_useStateApp9, 2),
    cartOpen = _useStateApp0[0],
    setCartOpen = _useStateApp0[1];
  var goTo = function goTo(s) {
    setScreen(s);
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  var openProduct = function openProduct(p) {
    setProduct(p);
    goTo("pdp");
  };
  var openCollection = function openCollection(id) {
    setCollId(id);
    goTo("collection");
  };
  var addToCart = function addToCart(p) {
    var i = cart.findIndex(function (it) {
      return it.id === p.id && it.size === (p.size || "M") && it.color === (p.color || (p.colors || [])[0]);
    });
    if (i >= 0) {
      var next = _toConsumableArray(cart);
      next[i] = _objectSpread(_objectSpread({}, next[i]), {}, {
        qty: (next[i].qty || 1) + (p.qty || 1)
      });
      setCart(next);
    } else {
      setCart([].concat(_toConsumableArray(cart), [_objectSpread(_objectSpread({}, p), {}, {
        size: p.size || "M",
        color: p.color || (p.colors || [])[0],
        qty: p.qty || 1
      })]));
    }
    setCartOpen(true);
  };
  var removeFromCart = function removeFromCart(i) {
    return setCart(cart.filter(function (_, idx) {
      return idx !== i;
    }));
  };
  var updateCart = function updateCart(i, patch) {
    return setCart(cart.map(function (it, idx) {
      return idx === i ? _objectSpread(_objectSpread({}, it), patch) : it;
    }));
  };

  // Checkout — use Shopify's native checkout
  var handleCheckout = function handleCheckout() {
    if (cart.length === 0) return;
    // Redirect to Shopify's checkout (uses Shopify session cart)
    // For full integration, items would be added via /cart/add.js first
    // using variant IDs from Storefront API. For now, send to /cart page.
    window.location.href = '/cart';
  };
  var onNav = function onNav(k) {
    if (k === "home") goTo("home");else if (k === "shop") openCollection("best-sellers");else if (typeof k === "string" && k.startsWith("shop:")) {
      var id = k.replace("shop:", "");
      var m = {
        "new-arrivals": "new-arrivals",
        "best-sellers": "best-sellers",
        "feminist": "feminist",
        "lgbtq-pride": "lgbtq-pride",
        "protest": "protest",
        "funny-and-political": "funny-and-political",
        "womens-tees": "womens-tees",
        "unisex-tees": "unisex-tees",
        "hoodies": "hoodies",
        "accessories": "accessories"
      }[id] || "best-sellers";
      openCollection(m);
    } else if (k === "movement") goTo("home");else if (k === "movement:causes") {
      goTo("home");
      setTimeout(function () {
        var _document$getElementB;
        return (_document$getElementB = document.getElementById("issues")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollIntoView({
          behavior: "smooth"
        });
      }, 80);
    } else if (k === "movement:calendar") {
      window.location.href = '/pages/protest-calendar';
    } else if (k === "movement:dispatch") {
      window.location.href = '/blogs/the-dispatch';
    } else if (k === "movement:submit-art") {
      window.location.href = '/pages/submit-your-art';
    } else if (k === "journal") {
      window.location.href = '/blogs/the-dispatch';
    } else if (k === "about") {
      goTo("home");
      setTimeout(function () {
        var _document$getElementB4;
        return (_document$getElementB4 = document.getElementById("manifesto")) === null || _document$getElementB4 === void 0 ? void 0 : _document$getElementB4.scrollIntoView({
          behavior: "smooth"
        });
      }, 80);
    } else if (k === "contact") window.location.href = "mailto:hello@rebelsandrights.com";
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: "var(--bone)"
    }
  }, /*#__PURE__*/React.createElement(Header, {
    cartCount: cart.reduce(function (s, it) {
      return s + (it.qty || 1);
    }, 0),
    onCartClick: function onCartClick() {
      return setCartOpen(true);
    },
    onNav: onNav,
    current: screen === "home" ? "home" : screen === "collection" ? "shop" : screen
  }), screen === "home" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Hero, {
    onShop: function onShop() {
      return openCollection("best-sellers");
    },
    onPdp: openProduct
  }), /*#__PURE__*/React.createElement(ValueStrip, null), /*#__PURE__*/React.createElement(FeaturedCollections, {
    onCollection: openCollection
  }), /*#__PURE__*/React.createElement(ProductRow, {
    products: [PRODUCTS[0], PRODUCTS[4], PRODUCTS[11], PRODUCTS[7]],
    eyebrow: "Most wanted",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Best ", /*#__PURE__*/React.createElement("em", {
      style: {
        fontStyle: "italic"
      }
    }, "sellers.")),
    lede: "The designs that hit hardest. Reorder yourself a fresh one.",
    onCard: openProduct,
    onAdd: addToCart,
    onMore: function onMore() {
      return openCollection("best-sellers");
    }
  }), /*#__PURE__*/React.createElement("div", {
    id: "issues"
  }, /*#__PURE__*/React.createElement(IssuesBlock, {
    onCause: openCollection
  })), /*#__PURE__*/React.createElement(Manifesto, null), /*#__PURE__*/React.createElement(ProductRow, {
    products: [PRODUCTS[8], PRODUCTS[9], PRODUCTS[10], PRODUCTS[13]],
    eyebrow: "Just printed",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "New ", /*#__PURE__*/React.createElement("em", {
      style: {
        fontStyle: "italic"
      }
    }, "arrivals.")),
    lede: "Fresh designs and restocked staples \u2014 shipped within the week.",
    onCard: openProduct,
    onAdd: addToCart,
    onMore: function onMore() {
      return openCollection("new-arrivals");
    }
  }), /*#__PURE__*/React.createElement(CalendarBlock, {
    onMore: function onMore() {
      return onNav("movement:calendar");
    }
  }), /*#__PURE__*/React.createElement(DispatchBlock, null), /*#__PURE__*/React.createElement(Testimonials, null), /*#__PURE__*/React.createElement(Newsletter, null)), screen === "collection" && /*#__PURE__*/React.createElement(CollectionPage, {
    id: collId,
    onCard: openProduct,
    onAdd: function onAdd(p) {
      return addToCart(p);
    },
    onBack: function onBack() {
      return goTo("home");
    }
  }), screen === "pdp" && /*#__PURE__*/React.createElement(ProductDetailPage, {
    product: product,
    onAdd: addToCart,
    onCard: openProduct,
    onBack: function onBack() {
      return goTo("collection");
    }
  }), /*#__PURE__*/React.createElement(Footer, {
    onNav: onNav
  }), /*#__PURE__*/React.createElement(CartDrawer, {
    open: cartOpen,
    items: cart,
    onClose: function onClose() {
      return setCartOpen(false);
    },
    onRemove: removeFromCart,
    onUpdate: updateCart,
    onCheckout: handleCheckout,
    onCard: function onCard(p) {
      setCartOpen(false);
      openProduct(p);
    }
  }));
}
ReactDOM.createRoot(document.getElementById("root")).render(/*#__PURE__*/React.createElement(App, null));
